import fetch from "@src/common/lib/axios";
const API = {
  queryAccoutsByPage({
    accountGroupName = "",
    pageNo = 1,
    pageSize = 10,
    that = this,
    caller = undefined
  }) {
    that.currentPage = pageNo;
    const params = {
      accountGroupName: accountGroupName,
      pageNo: pageNo,
      pageSize: pageSize
    };
    fetch("cms/accountGroup/queryResultsByPage.json", params).then(
      (response) => {
        caller(that, response);
      }
    );
  },
  queryAccountByAccountGroup: "cms/accountGroup/getAccountByAccountGroup.json",
  queryAccout() {
    return fetch("/cms/account/queryAccountListByAuthority.json", {});
  },
  insertRelationForAccount: "/cms/accountGroup/insertRelationForAccount.json",
  addRole: "/cms/accountGroup/add.json",
  updateRole: "/cms/accountGroup/update.json",
  queryMenu: "/cms/account/getMenusByAccount.json",
  queryMenuGroup: "cms/accountGroup/queryMenusByAccountGroup.json"
};

export default API;
